import React, { useState } from "react";
import { Box, Grid, TextField, Typography, Button, Modal, MenuItem } from "@mui/material";
import cross from "../../assets/img/cross.png";
import { createUser } from "../../api/Api"; // Assuming you have this API function
import { useTheme } from "@mui/material/styles";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const AddUserModal = ({ open, handleClose, handleSubmit }) => {
  const theme = useTheme();
  const [name, setname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setphone] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [area, setarea] = useState("");
  const [password, setPassword] = useState(""); 
  const [loading, setLoading] = useState(false);
  const areas = ["Sailashree vihar", "Niladri vihar", "Nandan vihar"]; 

  const onSubmit = async (e) => {
    e.preventDefault();

    // Collect user data
    const userData = { name, email, phone, selectedArea, area, password };

    try {
      setLoading(true); // Set loading to true
      const response = await createUser(userData);
      
      // Handle success
      if (response && (response.status === 200 || response.status === 201)) {
        handleSubmit(userData);
        handleClose();
      } else {
        console.error("Error creating user", response);
      }
    } catch (error) {
      console.error("Error creating user:", error);
    } finally {
      setLoading(false); // Reset loading state
      handleClose();
    }
  };

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="add-user-modal-title">
      <Box sx={style} component="form" onSubmit={onSubmit}>
        {/* Modal Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "20px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography id="add-user-modal-title" variant="h6" component="h2">
            Add User Details
          </Typography>
          <Box
            component="img"
            src={cross}
            alt="Close"
            sx={{
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
            onClick={handleClose} // Closes the modal when clicked
          />
        </Box>

        {/* Modal Body */}
        <Box sx={{ padding: "20px", flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={name}
                onChange={(e) => setname(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Contact No."
                value={phone}
                onChange={(e) => setphone(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                select
                label="Select Area"
                value={selectedArea}
                onChange={(e) => setSelectedArea(e.target.value)}
                variant="outlined"
                required
              >
                {areas.map((area, index) => (
                  <MenuItem key={index} value={area}>
                    {area}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Update password state
                variant="outlined"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Delivery Area"
                value={area}
                onChange={(e) => setarea(e.target.value)}
                variant="outlined"
                required
              />
            </Grid>
          </Grid>
        </Box>

        {/* Save Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button
            type="submit"
            variant="contained"
            sx={{
              width: "150px",
              padding:"15px",
              backgroundColor: theme.palette.primary.light,
            }}
            disabled={loading}
          >
            {loading ? "Please wait..." : "Save Data"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUserModal;
